// extracted by mini-css-extract-plugin
export default {"row1":"style_row1__knbXX","footer_btn":"style_footer_btn__Bjnwv","reserved":"style_reserved__9HwB1","footerLogo":"style_footerLogo__3UTHF"};